module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/1c22f071ddc6bfc03db07a87f551e4c4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_time.svg
// module id = PkTN
// module chunks = 0